import React from 'react';
import { MuiAppBar, MuiToolbar, MuiTypography, MuiGrid } from '../index';
import appConfig from '../../../config';
import { muiWithStyles, MuiButton, MuiHidden, MuiClickAwayListener, MuiAccountCircle, MuiMenu, MuiMenuItem, MuiIconButton, MuiNotificationsActiveIcon, MuiKeyboardArrowDown } from '../MaterialUIComponents';
import theme from '../../../assests';
import MenuItems from '../MenuItems';
import { Link } from 'react-router-dom';
import SignOutContainer from '../../functional/authentication/signout/SignOutContainer';
import SchoolMenuListComponent from './SchoolMenuListComponent'
import ProfileMenu from './ProfileMenu';
import HelpMenu from './HelpMenu';
import * as systemConfig from '../../../../src/systemConfig.json';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    backgroundColor: 'white',
    zIndex: 1000,
  },
 
});
/**
 *
 * @param props - position,color,textVariant,textColor,text,style,appBarContent
 */


const Appbar = (props) => {
  const classes = useStyles();

  const {
    onClick,
    onClickOfHelp,
    handleClose,
    isMenuOpen = false,
    anchorElForHelp = false,
  } = props;

  let loggedOutHeader = (
    <MuiAppBar classes={{
      root: classes.root}} >
      <MuiToolbar>
        <MuiGrid justify='space-between' alignItems='center' container spacing={24} >
          <MuiGrid xs container >


            <a href="https://www.schoolpivot.com/" target="_blank">
              <img src={theme.imageAlbum.toolbarLogo} style={theme.appLogoStyle}

              /></a>

          </MuiGrid>
          <MuiGrid item>

            <MuiMenu
              id="simple-menu"
              anchorEl={anchorElForHelp}
              keepMounted
              open={Boolean(anchorElForHelp)}
              onClose={handleClose}
            >
              <HelpMenu />
            </MuiMenu>
            <MuiButton key='pricing' style={theme.appBarTextItem} href={systemConfig.pricing} target="_blank">PRICING</MuiButton>
            <MuiButton key='resources' style={theme.appBarTextItem} href={systemConfig.resource} target="_blank">RESOURCES</MuiButton>
            <MuiButton key='helpcenter' style={theme.appBarTextItem} href={systemConfig.help} target="_blank">HELP</MuiButton>
            {/* <MuiButton key='contactus' style={theme.appBarTextItem} href='/contactus'>Contact</MuiButton> */}
            {/* <MuiButton key='login' style={theme.appBarTextItem} href='/login'>Sign up / Login</MuiButton> <a href={systemConfig.termsAndConditionsURL} target="_blank">
         */}
          </MuiGrid>
        </MuiGrid>
      </MuiToolbar>
    </MuiAppBar>
  )

  let loggedInHeader = (
    <MuiAppBar classes={{
      root: classes.root
    }}>
      <MuiClickAwayListener onClickAway={handleClose}>
        <MuiToolbar>
          <MuiGrid justify='space-between' alignItems='center' container spacing={24} direction='row'>

            <MuiGrid>
              <MuiButton style={theme.appBarTextItem} href="https://www.schoolpivot.com/" target="_blank" >

                <img src={theme.imageAlbum.toolbarLogo} style={theme.appLogoStyle}

                />
              </MuiButton>
            </MuiGrid>




            <MuiGrid container alignItems='center' xs justify='flex-end' >
              <MuiGrid item>
                <MuiButton key='pricing' style={theme.appBarTextItem} href={systemConfig.pricing} target="_blank">PRICING</MuiButton></MuiGrid>
              <MuiGrid item>
                {/* <MuiButton key='account' style={theme.appBarTextItem} href='/account'>Account</MuiButton>
              <MuiButton key='howto' style={theme.appBarTextItem} href='/howtovideos'>How to Videos</MuiButton> */}
              <MuiButton key='resources' style={theme.appBarTextItem} href={systemConfig.resource} target="_blank">RESOURCES</MuiButton>
                <MuiButton key='helpcenter' style={theme.appBarTextItem} href={systemConfig.help} target="_blank">HELP</MuiButton>
                {/* <MuiMenu
                  id="simple-menu"
                  anchorEl={anchorElForHelp}
                  keepMounted
                  open={Boolean(anchorElForHelp)}
                  onClose={handleClose}
                >
                  <HelpMenu />
                </MuiMenu> */}
                </MuiGrid>
              {/* <MuiButton key='contactus' style={theme.appBarTextItem} href='/contactus'>Contact</MuiButton> */}


              {/* 
              <MuiIconButton

                aria-haspopup="true"
                //onClick={props.onClick}
                style={{ color: 'white', cursor: 'hand' }}
              >
                <MuiNotificationsActiveIcon />
              </MuiIconButton> */}
              <MuiGrid><SchoolMenuListComponent {...props} /></MuiGrid>
              <MuiGrid item>
                <MuiIconButton

                  aria-controls="simple-menu" aria-haspopup="true"
                  onClick={props.onClick}
                  style={{ color: 'white', cursor: 'hand' }}
                >
                  <MuiAccountCircle style={{ fontSize: 40, color: theme.palette.primary.darker }} />
                </MuiIconButton>
                <MuiMenu
                  id="menu-appbar"
                  anchorEl={isMenuOpen}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(isMenuOpen)}
                  onClose={handleClose}
                >
                  <ProfileMenu handleClose={handleClose} cognitoUser={props.cognitoUser} />
                </MuiMenu>
              </MuiGrid></MuiGrid>
          </MuiGrid></MuiToolbar>
      </MuiClickAwayListener>
    </MuiAppBar>
  )
  return (props.cognitoUser != null ? loggedInHeader : loggedOutHeader);
};

export default Appbar;